import { Badge } from "@devhop/ui";
import { resolveEffectiveCfAllocationMode } from "@/modules/cf-feed/domain/lib/cf-allocation-mode";
import type { FeedSessionProductRow } from "../api/types";

export function SessionProductQuota({
  product,
}: {
  product: Pick<
    FeedSessionProductRow,
    "allocationMode" | "allocatedQuantity" | "isPreorder"
  >;
}) {
  const limited =
    resolveEffectiveCfAllocationMode(
      product.allocationMode,
      product.isPreorder,
    ) === "limit";
  return (
    <div className="space-y-1">
      <Badge
        variant={limited ? "outline" : "secondary"}
        className="font-normal"
      >
        {limited ? "CF ຈຳກັດຕາມ POS" : "CF ບໍ່ຈຳກັດ"}
      </Badge>
      <p className="text-muted-foreground text-xs">
        {limited ? "ອີງຕາມສະຕັອກຄົງເຫຼືອ POS" : "POS ເປີດ preorder"}
      </p>
    </div>
  );
}
